import $ from 'jquery';
window.$ = window.jQuery = $;

import ScrollMagic from 'scrollmagic';
window.ScrollMagic = ScrollMagic;